import { API_TYPE } from '@umu/umu-fetch';
const BASE_API = '/uapi/v1';
const BASE_AJAX = '/ajax/enterprise';

const API = {
    GET_COURSE_LIST: {
        url: `${BASE_AJAX}/getReportGroupList`,
        type: API_TYPE.GET,
    },
    GET_PROGRAM_LIST: {
        url: `${BASE_AJAX}/getReportProgramList`,
        type: API_TYPE.GET,
    },
    GET_SESSION_LIST: {
        url: `${BASE_AJAX}/getReportSessionList`,
        type: API_TYPE.GET,
    },
    GET_LECTURER_LIST: {
        url: `${BASE_API}/dashboard/teacher-list`,
        type: API_TYPE.GET,
    },
    GET_MICRO_PAGES_LIST: {
        url: `${BASE_API}/micro-page/page/list`,
        type: API_TYPE.GET,
    },
    GET_ACCOUNT_LIST: {
        url: '/api/manage/getcourseaccesslist', // 获取设置权限账号
        type: API_TYPE.GET,
    },
    GET_CATEGORY_LIST: {
        url: `${BASE_API}/enterprise/get-category-list`, // 获取分类信息
        type: API_TYPE.GET,
    },
    GET_PRACTICE_CHANNEL_LIST: {
        url: `${BASE_API}/enterprise/se-channel-list`, // 获取练习频道
        type: API_TYPE.GET,
    },
    GET_PRACTICE_CAN_RELATION: {
        url: `${BASE_API}/channel/can-relation`,
        type: API_TYPE.GET,
    },
    GET_USER_LIST: {
        url: `${BASE_API}/enterprise/user-list`,
        type: API_TYPE.GET,
    },
    GET_GROUP_LIST: {
        url: `${BASE_API}/enterprise/enterprise-group-list`,
        type: API_TYPE.GET,
    },
    GET_DEPARTMENT_LIST: {
        url: `${BASE_API}/department/get-departments-by-managerid`,
        type: API_TYPE.GET,
    },
    GET_DEPARTMENT_BY_SUG_LIST: {
        url: `${BASE_API}/department/sug`,
        type: API_TYPE.GET,
    },
    GET_UNREAD_COUNT: {
        url: `${BASE_API}/message/get-unread-count`,
        type: API_TYPE.GET,
    },
};

export { API };
